// Keep Umi's locale registry lightweight. Complete messages are loaded on demand
// from `localeBundles/zh-TW` during application startup.
export default {};
